<template>
  <div class="income-workbench">
    <section class="toolbar-panel glass-panel">
      <div class="income-filter-row">
        <label class="hf-form-item filter-id">
          <span class="hf-label">视频号ID</span>
          <input class="hf-field" v-model="queryParams.videoNoUserId" placeholder="请输入视频号ID">
        </label>
        <label class="hf-form-item filter-name">
          <span class="hf-label">剧名</span>
          <input class="hf-field" v-model="queryParams.mediaName" placeholder="请输入剧名">
        </label>
        <label class="hf-form-item filter-date">
          <span class="hf-label">开始日期</span>
          <input class="hf-field" v-model="queryParams.startTime" type="date">
        </label>
        <label class="hf-form-item filter-date">
          <span class="hf-label">结束日期</span>
          <input class="hf-field" v-model="queryParams.endTime" type="date">
        </label>
        <label class="hf-form-item mount-filter">
          <span class="hf-label">是否挂载</span>
          <select class="hf-select" v-model="mountValue" @change="syncMountValue">
            <option value="">全部</option>
            <option value="true">是</option>
            <option value="false">否</option>
          </select>
        </label>
        <div class="form-actions">
          <button class="hf-btn hf-btn--primary" type="button" @click="handleQuery">搜索</button>
          <button class="hf-btn" type="button" @click="resetQuery">重置</button>
          <button class="hf-btn hf-btn--primary" type="button" :disabled="isStating" @click="handleStatic">
            {{ isStating ? '统计中' : '统计' }}
          </button>
        </div>
      </div>
    </section>

    <section class="table-panel glass-panel">
      <div class="action-row">
        <button class="hf-btn hf-btn--primary" type="button" @click="handleImport">批量导入</button>
        <button class="hf-btn" type="button" :disabled="fullscreenLoading" @click="handleExport">
          {{ fullscreenLoading ? '导出中' : '导出' }}
        </button>
        <button class="hf-btn" type="button" @click="handleFilter">隐藏规则</button>
      </div>

      <div class="hf-table-wrap">
        <table class="hf-table income-table">
          <colgroup>
            <col class="col-date">
            <col class="col-name">
            <col class="col-id">
            <col class="col-id">
            <col class="col-name">
            <col class="col-id-wide">
            <col class="col-title">
            <col class="col-status">
            <col class="col-number">
            <col class="col-number">
            <col class="col-money">
          </colgroup>
          <thead>
            <tr>
              <th>日期</th>
              <th>剧名</th>
              <th>剧目ID</th>
              <th>视频号ID</th>
              <th>视频号昵称</th>
              <th>视频ID</th>
              <th>视频标题</th>
              <th>是否挂载</th>
              <th>视频播放量</th>
              <th>剧集播放量</th>
              <th>收益</th>
            </tr>
          </thead>
          <tbody v-if="incomeStaticList.length">
            <tr v-for="row in incomeStaticList" :key="row.id || `${row.collectDate}_${row.videoId}`">
              <td>{{ row.collectDate }}</td>
              <td :data-tooltip="row.mediaName || null">{{ row.mediaName }}</td>
              <td :data-tooltip="row.mediaId || null">{{ row.mediaId }}</td>
              <td :data-tooltip="row.videoNoUserId || null">{{ row.videoNoUserId }}</td>
              <td :data-tooltip="row.videoNoUserName || null">{{ row.videoNoUserName }}</td>
              <td :data-tooltip="row.videoId || null">{{ row.videoId }}</td>
              <td class="title-cell" :data-tooltip="row.videoTitle || null">{{ row.videoTitle }}</td>
              <td class="status-cell">
                <span class="hf-tag" :class="row.isMount ? 'hf-tag--success' : 'hf-tag--danger'">
                  {{ row.isMount ? '是' : '否' }}
                </span>
              </td>
              <td class="number-cell">{{ row.videoVisitNum }}</td>
              <td class="number-cell">{{ row.videoSerialsNum }}</td>
              <td class="number-cell">{{ row.advertisingRevenue }}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="!incomeStaticList.length && !loading" class="hf-table-empty">暂无投放数据</div>
        <div v-if="loading" class="hf-loading">加载中...</div>
      </div>

      <div class="pagination-wrap">
        <div class="hf-pagination">
          <button class="hf-page-btn" type="button" :disabled="now <= 1" @click="findPage(now - 1)">‹</button>
          <button
            v-for="page in pageNumbers"
            :key="page"
            class="hf-page-btn"
            :class="{ active: page === now }"
            type="button"
            @click="findPage(page)"
          >{{ page }}</button>
          <button class="hf-page-btn" type="button" :disabled="now >= pageCount" @click="findPage(now + 1)">›</button>
          <select class="hf-select page-size" v-model.number="size" @change="findSize(size)">
            <option v-for="item in [10, 30, 50, 100]" :key="item" :value="item">{{ item }} 条/页</option>
          </select>
          <span>共 {{ total }} 条</span>
        </div>
      </div>
    </section>

    <div v-if="filterDialogVisible" class="hf-modal-mask">
      <section class="hf-modal hf-modal--wide">
        <div class="hf-modal__header">
          <h3 class="hf-modal__title">隐藏规则</h3>
          <button class="hf-modal__close" type="button" @click="filterDialogVisible = false">×</button>
        </div>
        <div class="filter-tags">
          <span
            v-for="tag in nonVideoNoUserIdList"
            :key="tag"
            class="hf-tag"
          >
            {{ tag }}
            <button type="button" @click="nonVideoNoUserIdHandleClose(tag)">×</button>
          </span>
        </div>
        <div class="tag-input-row">
          <input
            v-if="nonVideoNoUserIdVisible"
            ref="saveTagInput"
            class="hf-field input-new-tag"
            v-model="nonVideoNoUserIdValue"
            @keyup.enter="nonVideoNoUserIdConfirm"
            @blur="nonVideoNoUserIdConfirm"
          >
          <button v-else class="hf-btn" type="button" @click="nonVideoNoUserIdInput">+ 视频号ID</button>
        </div>
        <div class="action-buttons">
          <button class="hf-btn hf-btn--primary" type="button" @click="submitFilter">确定</button>
        </div>
      </section>
    </div>

    <div v-if="statisticDialogVisible" class="hf-modal-mask">
      <section class="hf-modal hf-modal--wide">
        <div class="hf-modal__header">
          <div>
            <p class="modal-kicker">STATISTIC</p>
            <h3 class="hf-modal__title">统计结果</h3>
          </div>
          <button class="hf-modal__close" type="button" @click="statisticDialogVisible = false">×</button>
        </div>
        <div class="stat-grid stat-grid--modal">
          <div class="stat-card">
            <p class="stat-label">视频播放量</p>
            <div class="stat-value">{{ statistic.videoVisitNum || 0 }}</div>
          </div>
          <div class="stat-card">
            <p class="stat-label">剧集播放量</p>
            <div class="stat-value">{{ statistic.videoSerialsNum || 0 }}</div>
          </div>
          <div class="stat-card">
            <p class="stat-label">收益</p>
            <div class="stat-value">{{ statistic.advertisingRevenue || 0 }}</div>
          </div>
        </div>
      </section>
    </div>

    <div v-if="importDialogVisible" class="hf-modal-mask">
      <section class="hf-modal">
        <div class="hf-modal__header">
          <h3 class="hf-modal__title">Excel 批量导入</h3>
          <button class="hf-modal__close" type="button" :disabled="uploading" @click="closeImportDialog">×</button>
        </div>
        <label class="upload-box">
          <input ref="fileInput" type="file" accept=".xlsx,.xls" multiple @change="handleFileChange">
          <span class="upload-icon">⇧</span>
          <strong>{{ selectedFiles.length ? `已选择 ${selectedFiles.length} 个 Excel 文件` : '选择多个 Excel 文件' }}</strong>
          <small>请上传 .xls 或 .xlsx 格式，单个文件大小不超过 100MB</small>
        </label>
        <ul v-if="selectedFiles.length" class="upload-file-list">
          <li
            v-for="(file, index) in selectedFiles"
            :key="`${file.name}_${file.size}_${index}`"
            :class="{ active: uploading && index === uploadIndex }"
          >
            <span>{{ index + 1 }}. {{ file.name }}</span>
            <small>{{ formatFileSize(file.size) }}</small>
          </li>
        </ul>
        <div class="action-buttons file-info">
          <button class="hf-btn hf-btn--primary" type="button" :disabled="!selectedFiles.length || uploading" @click="submitUpload">
            {{ uploading ? `上传中 ${uploadIndex + 1}/${selectedFiles.length}` : '开始上传' }}
          </button>
          <button class="hf-btn" type="button" :disabled="uploading" @click="resetUpload">清除</button>
        </div>
        <div class="result-message" v-if="resultMessage" :class="resultType">
          {{ resultMessage }}
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {
  exportNlPromotionIncomeStatic,
  getNlPromotionIncomeFilter,
  pageNlPromotionIncomeStatic,
  statisticNlPromotionIncomeStatic,
  updateNlPromotionIncomeFilter
} from "@/api/IncomeStatic";
import { saveAs } from 'file-saver'

export default {
  props: {
    isMiniProgram: {
      default: 0
    }
  },
  data() {
    return {
      fullscreenLoading: false,
      isStating: false,
      mountValue: '',
      nonVideoNoUserIdList: [],
      nonVideoNoUserIdVisible: false,
      nonVideoNoUserIdValue: '',
      uploadUrl: '/api/nlPromotionIncomeStatic/import/',
      importDialogVisible: false,
      filterDialogVisible: false,
      statisticDialogVisible: false,
      selectedFiles: [],
      uploadIndex: 0,
      uploading: false,
      resultMessage: '',
      resultType: 'success',
      total: 0,
      now: 1,
      size: 10,
      loading: false,
      queryParams: {
        isMiniProgram: this.isMiniProgram !== undefined && this.isMiniProgram !== null ? this.isMiniProgram : 0,
      },
      incomeStaticList: [],
      statistic: {},
    };
  },
  computed: {
    programFlag() {
      return this.isMiniProgram !== undefined && this.isMiniProgram !== null
        ? this.isMiniProgram
        : 0;
    },
    pageCount() {
      return Math.max(1, Math.ceil(this.total / this.size));
    },
    pageNumbers() {
      const pages = [];
      const start = Math.max(1, this.now - 2);
      const end = Math.min(this.pageCount, start + 4);
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  mounted() {
    this.getList();
  },
  watch: {
    programFlag(value) {
      this.queryParams.isMiniProgram = value;
    }
  },
  methods: {
    syncMountValue() {
      if (this.mountValue === '') {
        this.$delete(this.queryParams, 'isMount');
      } else {
        this.$set(this.queryParams, 'isMount', this.mountValue === 'true');
      }
    },
    handleFileChange(event) {
      const files = Array.from(event.target.files || []);
      if (!files.length) return;
      const invalidFile = files.find(file => !this.beforeUpload(file, false));
      if (invalidFile) {
        this.resultType = 'error';
        this.resultMessage = this.getFileErrorMessage(invalidFile);
        event.target.value = '';
        return;
      }
      this.selectedFiles = files;
      this.uploadIndex = 0;
      this.resetResult();
    },
    beforeUpload(file, updateMessage = true) {
      const isExcel = /\.(xls|xlsx)$/i.test(file.name);
      const isLt100M = file.size / 1024 / 1024 < 100;

      if (updateMessage && !isExcel) {
        this.resultType = 'error';
        this.resultMessage = '只能上传 Excel 格式的文件（.xls 或 .xlsx）';
      } else if (updateMessage && !isLt100M) {
        this.resultType = 'error';
        this.resultMessage = '上传文件大小不能超过 100MB';
      }

      return isExcel && isLt100M;
    },
    getFileErrorMessage(file) {
      if (!/\.(xls|xlsx)$/i.test(file.name)) {
        return `「${file.name}」不是 Excel 文件，只支持 .xls 或 .xlsx`;
      }
      if (file.size / 1024 / 1024 >= 100) {
        return `「${file.name}」超过 100MB`;
      }
      return '文件不符合上传要求';
    },
    async submitUpload() {
      if (!this.selectedFiles.length) {
        this.$message.warning('请先选择 Excel 文件');
        return;
      }

      this.resetResult();
      this.uploading = true;
      this.uploadIndex = 0;

      try {
        for (let i = 0; i < this.selectedFiles.length; i++) {
          this.uploadIndex = i;
          const formData = new FormData();
          formData.append('file', this.selectedFiles[i]);
          await axios.post(this.uploadUrl + this.programFlag, formData, {
            headers: this.getUploadHeaders()
          });
        }
        this.uploading = false;
        this.selectedFiles = [];
        this.uploadIndex = 0;
        this.clearFileInput();
        this.getList();
        this.resultType = 'success';
        this.resultMessage = 'Excel 文件全部上传成功，后台将异步解析导入';
        this.$notify({ title: '上传成功', message: 'Excel 文件已全部提交', type: 'success' });
        this.importDialogVisible = false;
        this.$emit('upload-success');
      } catch (err) {
        this.uploading = false;
        const failedFile = this.selectedFiles[this.uploadIndex];
        const message = err.response && err.response.data
          ? (err.response.data.msg || err.response.data.message || '上传失败')
          : '上传失败';
        this.$notify({ title: '导入失败', message, type: 'error' });
        this.resultType = 'error';
        this.resultMessage = failedFile ? `「${failedFile.name}」上传失败：${message}` : message;
        this.$emit('upload-error', err);
      }
    },
    getUploadHeaders() {
      const token = localStorage.getItem('oauthToken') || sessionStorage.getItem('loginToken') || '';
      const headers = {};
      if (token) {
        headers.oauthToken = token;
        headers.Token = token;
        headers.Authorization = `Bearer ${token}`;
      }
      return headers;
    },
    resetUpload() {
      this.selectedFiles = [];
      this.uploadIndex = 0;
      this.uploading = false;
      this.clearFileInput();
      this.resetResult();
    },
    clearFileInput() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    resetResult() {
      this.resultMessage = '';
    },
    closeImportDialog() {
      if (this.uploading) return;
      this.importDialogVisible = false;
    },
    formatFileSize(size) {
      if (!size) return '0 KB';
      if (size < 1024 * 1024) {
        return `${Math.ceil(size / 1024)} KB`;
      }
      return `${(size / 1024 / 1024).toFixed(2)} MB`;
    },
    getStatistic() {
      statisticNlPromotionIncomeStatic(this.queryParams).then(response => {
        this.statistic = response.data || {};
        this.statisticDialogVisible = true;
        this.isStating = false;
      }).catch(() => {
        this.isStating = false;
      });
    },
    getList() {
      this.loading = true;
      pageNlPromotionIncomeStatic(this.now, this.size, this.queryParams).then(response => {
        this.incomeStaticList = response.data.records;
        this.total = response.data.total;
      }).finally(() => {
        this.loading = false;
      });
    },
    submitFilter() {
      updateNlPromotionIncomeFilter({
        nonVideoNoUserIdList: this.nonVideoNoUserIdList,
      }).then(() => {
        this.filterDialogVisible = false;
      });
    },
    resetQuery() {
      this.mountValue = '';
      this.queryParams = {
        isMiniProgram: this.programFlag,
      };
      this.handleQuery();
    },
    handleQuery() {
      this.now = 1;
      this.getList();
    },
    handleStatic() {
      this.isStating = true;
      this.getStatistic();
    },
    handleImport() {
      this.resetUpload();
      this.importDialogVisible = true;
    },
    handleExport() {
      this.fullscreenLoading = true;
      exportNlPromotionIncomeStatic(this.queryParams).then(async (data) => {
        const blob = new Blob([data])
        saveAs(blob, `推广收入统计_${new Date().getTime()}.xlsx`)
      }).catch((r) => {
        console.error(r)
      }).finally(() => {
        this.fullscreenLoading = false;
      })
    },
    handleFilter() {
      getNlPromotionIncomeFilter().then((res) => {
        this.nonVideoNoUserIdList = res.data.nonVideoNoUserIdList || [];
      })
      this.filterDialogVisible = true;
    },
    findPage(nowPage) {
      this.now = nowPage;
      this.showPageInfo(nowPage, this.size);
    },
    findSize(nowSize) {
      this.size = nowSize;
      this.now = 1;
      this.showPageInfo(this.now, nowSize);
    },
    showPageInfo(currentPage, pageSize) {
      currentPage = currentPage || this.now;
      pageSize = pageSize || this.size;
      this.selectResolveAddress(currentPage, pageSize);
    },
    selectResolveAddress(currentPage, pageSize) {
      this.loading = true;
      pageNlPromotionIncomeStatic(currentPage, pageSize, this.queryParams).then((res) => {
        this.incomeStaticList = res.data.records;
        this.total = res.data.total;
      }).finally(() => {
        this.loading = false;
      });
    },
    nonVideoNoUserIdHandleClose(tag) {
      this.nonVideoNoUserIdList.splice(this.nonVideoNoUserIdList.indexOf(tag), 1);
    },
    nonVideoNoUserIdInput() {
      this.nonVideoNoUserIdVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput && this.$refs.saveTagInput.focus();
      });
    },
    nonVideoNoUserIdConfirm() {
      let inputValue = this.nonVideoNoUserIdValue;
      if (inputValue) {
        this.nonVideoNoUserIdList.push(inputValue);
      }
      this.nonVideoNoUserIdVisible = false;
      this.nonVideoNoUserIdValue = '';
    }
  }
};
</script>

<style scoped>
.income-workbench {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.income-filter-row {
  display: flex;
  align-items: flex-end;
  flex-wrap: nowrap;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 2px;
}

.filter-id {
  flex: 0 0 150px;
}

.filter-name {
  flex: 0 0 160px;
}

.filter-date {
  flex: 0 0 142px;
}

.form-actions {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-end;
  flex-wrap: nowrap;
  gap: 8px;
}

.mount-filter {
  flex: 0 0 104px;
}

.income-table {
  min-width: 1380px;
}

.income-table .col-date {
  width: 112px;
}

.income-table .col-name {
  width: 150px;
}

.income-table .col-id {
  width: 136px;
}

.income-table .col-id-wide {
  width: 176px;
}

.income-table .col-title {
  width: 240px;
}

.income-table .col-status {
  width: 96px;
}

.income-table .col-number {
  width: 116px;
}

.income-table .col-money {
  width: 116px;
}

.income-table .title-cell {
  color: #101828;
  font-weight: 700;
}

.income-table .status-cell {
  text-align: center;
}

.income-table .number-cell {
  color: #101828;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  text-align: right;
}

.pagination-wrap {
  display: flex;
  justify-content: flex-start;
  padding-top: 14px;
  overflow-x: auto;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
}

.filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 38px;
}

.tag-input-row {
  margin-top: 14px;
}

.input-new-tag {
  width: 160px;
}

.upload-box {
  display: grid;
  place-items: center;
  min-height: 176px;
  border: 1px dashed rgba(15, 23, 42, .16);
  border-radius: 16px;
  background: rgba(255, 255, 255, .58);
  cursor: pointer;
  gap: 8px;
  padding: 22px;
  text-align: center;
}

.upload-box input {
  display: none;
}

.upload-icon {
  font-size: 26px;
}

.upload-file-list {
  display: grid;
  max-height: 180px;
  overflow: auto;
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
  gap: 8px;
}

.upload-file-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid rgba(15, 23, 42, .08);
  border-radius: 12px;
  background: rgba(248, 250, 252, .78);
  padding: 10px 12px;
}

.upload-file-list li.active {
  border-color: rgba(16, 24, 40, .22);
  background: rgba(234, 246, 255, .9);
}

.upload-file-list span {
  min-width: 0;
  overflow: hidden;
  color: #101828;
  font-size: 13px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-file-list small {
  flex: 0 0 auto;
}

.upload-box small,
.result-message {
  color: #667085;
}

.file-info {
  justify-content: flex-start;
}

.result-message {
  margin-top: 14px;
  border-radius: 12px;
  background: rgba(242, 244, 247, .78);
  padding: 12px;
}

.result-message.error {
  background: rgba(254, 243, 242, .9);
  color: #b42318;
}

.page-size {
  width: 110px;
}

.modal-kicker {
  margin: 0 0 5px;
  color: #98a2b3;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: .12em;
}

.stat-grid--modal .stat-card {
  box-shadow: none;
}

@media (max-width: 720px) {
  .income-filter-row {
    align-items: stretch;
    flex-direction: column;
    overflow-x: visible;
  }

  .filter-id,
  .filter-name,
  .filter-date,
  .mount-filter {
    flex: auto;
  }

  .form-actions {
    flex-wrap: wrap;
  }
}
</style>
